import { InjectionToken, Provider } from '@angular/core';

export type RmaButtonBrand = 'dashboard' | 'public' | 'microsites';

/**
 * The brand every `rmaButton` and slide toggle in the injector renders with unless its own `brand` input says
 * otherwise. Brand is a fact about the app, not the component — each app provides its own once
 * at bootstrap, and a single call site can still override per usage through the input.
 *
 * The factory default is `public` so the four public-branded apps need no provider; the
 * dashboard and promoter apps must provide `dashboard` or every button renders public paint.
 */
export const RMA_BUTTON_BRAND = new InjectionToken<RmaButtonBrand>('RMA_BUTTON_BRAND', {
  factory: () => 'public',
});

export function provideRmaButtonBrand(brand: RmaButtonBrand): Provider {
  return { provide: RMA_BUTTON_BRAND, useValue: brand };
}
